import { Job } from '../service-case/model/job';
import { JobV11 } from './v11/service-case/model/jobV11';
import { ValueUpdater } from '../valueUpdater';
import { DefectTransformer } from './defectTransformer';
import { FlatRateUnitTransformer } from './flatRateUnitTransformer';
import { PackageTransformer } from './packageTransformer';
import { PartTransformer } from './partTransformer';
import { JobV10 } from './v10/case/model/jobV10';
export class JobTransformer {
    static transformList(inVersion, outVersion, payload) {
        const resultList = [];
        payload.forEach((job) => {
            resultList.push(this.transform(inVersion, outVersion, job));
        });
        return resultList;
    }
    static transform(inVersion, outVersion, payload) {
        const transformation = String(inVersion) + '-to-' + String(outVersion);
        switch (transformation) {
            case '12-to-10':
                return this.transformFromV12ToV10(payload);
            case '12-to-11':
                return JobV11.constructFromPlainObject(payload);
            case '10-to-12':
                return this.transformFromV10ToV12(payload);
            case '11-to-12':
                return Job.constructFromPlainObject(payload);
            default:
                throw new Error('Unsupported transformation: ' + transformation);
        }
    }
    static transformFromV12ToV10(payload) {
        const job = Job.constructFromPlainObject(payload);
        const jobV10 = new JobV10(job.getTitle(), job.getComment(), job.getCustomerStatement(), DefectTransformer.transformList(12, 10, job.getDefects()), FlatRateUnitTransformer.transformList(12, 10, job.getFlatRateUnits()), PartTransformer.transformList(12, 10, job.getParts()), PackageTransformer.transformList(12, 10, job.getPackages()));
        jobV10.setExternalId(job.getExternalId());
        jobV10.setDemandCategory(job.getDemandCategory());
        jobV10.setDemandId(job.getDemandId());
        jobV10.setPositionNumber(ValueUpdater.updateNonNullableNumberOrUnknown(jobV10.getPositionNumber(), job.getPositionNumber()));
        jobV10.setSelected(ValueUpdater.updateNonNullableBoolean(jobV10.isSelected(), job.getIsSelected()));
        return jobV10;
    }
    static transformFromV10ToV12(payload) {
        const jobV10 = JobV10.constructFromPlainObject(payload);
        const job = new Job('', jobV10.getTitle());
        job.setComment(jobV10.getComment());
        job.setCustomerStatement(jobV10.getCustomerStatement());
        job.setDefects(DefectTransformer.transformList(10, 12, jobV10.getDefects()));
        job.setDemandCategory(ValueUpdater.updateNonNullableString(job.getDemandCategory(), jobV10.getDemandCategory()));
        job.setDemandId(ValueUpdater.updateNonNullableString(job.getDemandId(), jobV10.getDemandId()));
        job.setExternalId(ValueUpdater.updateNonNullableString(job.getExternalId(), jobV10.getExternalId()));
        job.setFlatRateUnits(FlatRateUnitTransformer.transformList(10, 12, jobV10.getFlatRateUnits()));
        job.setIsSelected(ValueUpdater.updateNonNullableField(job.getIsSelected(), jobV10.isSelected()));
        job.setPackages(PackageTransformer.transformList(10, 12, jobV10.getPackages()));
        job.setParts(PartTransformer.transformList(10, 12, jobV10.getParts()));
        job.setPositionNumber(ValueUpdater.updateNullableField(job.getPositionNumber(), jobV10.getPositionNumber()));
        if (job.getExternalId() === '') {
            console.debug('[AWP Lib] [SERVER]: Trying to transform Job from model V10 to V11, but the client was unable to' +
                ' provide mandatory field Job.externalId. Will set an empty string instead.');
        }
        return job;
    }
}
//# sourceMappingURL=jobTransformer.js.map